const api = {
  creteClientProfile: ({ data, client_id }) =>
    new Promise((resolve, reject) => {
      //   let myHeaders = new Headers();
      //   myHeaders.append("token", token);
      //   myHeaders.append("Content-Type", "application/json");
      let myHeaders = {};
      let _user = window.localStorage.getItem("_user");

      if (_user) {
        _user = JSON.parse(_user);
        myHeaders["Authorization"] = "Bearer " + _user.token;
        myHeaders["Content-Type"] = "application/json";
      }

      let raw = data;

      if (client_id) {
        raw["client_id"] = client_id;
      }
      raw = JSON.stringify(data);

      let requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      console.log({ data, _user, requestOptions });
      fetch(
        "https://api.iqcioadvisers.com/ajax_create_client_profile/",
        requestOptions
      )
        .then((res) => res.json())
        .then((data) => resolve(data))
        .catch((err) => reject(err));
    }),
};

export default api;



// WEBPACK FOOTER //
// ./src/components/pages/Create_portfolio_by_Advisor/model_portfolio/riskQuestionnaire/api.js